<template>
  <div class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">自定义数据</h2>
    </div>

    <div class="part__cnt">
      <div class="label_style mt-3">
        <template v-for="item in CustomValue" :key="item.label">
          <ul v-if="item.value !== '-'">
            <li v-if="item.value !== '-'">{{ item.label }}</li>
            <li v-if="item.value !== '-'">{{ item.value || '-' }}</li>
          </ul>
        </template>
        
        <template v-for="item in customNewFieldsData">
          <ul v-if="item.value !== '-'" :key="item.label">
            <li v-if="item.value !== '-'">{{ item.label }}</li>
            <li v-if="item.value !== '-'">{{ item.value || '-' }}</li>
          </ul>
        </template>
      </div>

      <div v-show="chartDataCstom?.rows?.['SMG-DrawCall,DrawCall']?.length" class="position-relative">
        <div id="custom_data" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="custom_data_chart" />
        <chart-rect ref="chartRect1" chartKey="custom_data_chart" />
      </div>

      <br />

      <div v-show="chartDataCstom?.rows?.['SMG-Primitives,Primitives']?.length" class="position-relative">
        <div
          id="custom_data_second"
          style="width: 100%; height: 400px"
        ></div>
        <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="custom_data_second_chart" />
        <chart-rect ref="chartRect2" chartKey="custom_data_second_chart" />
      </div>

      <div v-show="chartDataCstom?.rows?.['SMG-FPS,FPS']?.length" class="position-relative">
        <div id="custom_smg_fps" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList3" :perf_second_data="perf_second_data" chartKey="custom_smg_fps_chart" />
        <chart-rect ref="chartRect3" chartKey="custom_smg_fps_chart" />
      </div>

      <div v-show="hasData(['SMG-FrameTime,Frame', 'SMG-FrameTime,GPU', 'SMG-FrameTime,GT', 'SMG-FrameTime,RHI', 'SMG-FrameTime,RT'])" class="position-relative">
        <div id="custom_smg_frame" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList4" :perf_second_data="perf_second_data" chartKey="custom_smg_frame_chart" />
        <chart-rect ref="chartRect4" chartKey="custom_smg_frame_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

const useCharts = {
  props: {
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    chartDataCstom() {
      return this.perf_second_data?.['SMG自定义数据']
    },

    
  },

  methods: {
    getCustomOption() {
      return {
        title: {
          text: "SMG-DrawCall,DrawCall",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: {
          left: "3%",
          right: "4%",
          bottom: "25%",
          top: "25%",
        },
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataCstom?.rows?.timeline,
        },
        series: [
          {
            name: "SMG-DrawCall,DrawCall",
            type: "line",
            showSymbol: false,
            data: this.chartDataCstom?.rows?.["SMG-DrawCall,DrawCall"],
            itemStyle: this.chartSettings.itemStyle2,
          }
        ],
      }
    },

    drawPieChartcustom() {
      let chartDom = document.getElementById("custom_data")
      if (!chartDom) return
      if (!allChart.custom_data_chart) {
        allChart.custom_data_chart = echarts.init(chartDom)
      }
      allChart.custom_data_chart.setOption(this.getCustomOption(), {notMerge: true})
    },

    getSecondOption() {
      return {
        title: {
          text: "SMG-Primitives,Primitives",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: {
          left: "3%",
          right: "4%",
          bottom: "25%",
          top: "25%",
          containLabel: true,
        },
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataCstom?.rows?.timeline,
        },
        series: [
          {
            name: "SMG-Primitives,Primitives",
            type: "line",
            showSymbol: false,
            data: this.chartDataCstom?.rows?.["SMG-Primitives,Primitives"],
            itemStyle: this.chartSettings.itemStyle2,
          }
        ],
      }
    },

    drawPieChartcustomSecond() {
      let chartDom = document.getElementById("custom_data_second")
      if (!chartDom) return
      if (!allChart.custom_data_second_chart) {
        allChart.custom_data_second_chart = echarts.init(chartDom)
      }
      allChart.custom_data_second_chart.setOption(this.getSecondOption(), {notMerge: true})
    },

    getFpsOption() {
      return {
        title: {
          text: "SMG-FPS,FPS",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataCstom?.rows?.timeline,
        },
        series: [{
          name: "SMG-FPS,FPS",
          type: "line",
          showSymbol: false,
          data: this.chartDataCstom?.rows?.["SMG-FPS,FPS"],
          itemStyle: this.chartSettings.itemStyle2,
        }],
      }
    },

    drawChartCustom2() {
      let chartDom = document.getElementById("custom_smg_fps")
      if (!chartDom) return
      if (!allChart.custom_smg_fps_chart) {
        allChart.custom_smg_fps_chart = echarts.init(chartDom)
      }
      allChart.custom_smg_fps_chart.setOption(this.getFpsOption(), {notMerge: true})
    },

    hasData(arr) {
      const rows = this.chartDataCstom?.rows
      let has = false

      for (let item of arr) {
        if (rows?.[item]?.filter(item => item)?.length) {
          has = true
          break
        }
      }

      return has
    },

    getFrameOption() {
      return {
        title: {
          text: "SMG-FrameTime",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataCstom.rows.timeline,
        },
        series: ['SMG-FrameTime,Frame', 'SMG-FrameTime,GPU', 'SMG-FrameTime,GT', 'SMG-FrameTime,RHI', 'SMG-FrameTime,RT'].map(item => ({
          name: item,
          type: "line",
          showSymbol: false,
          data: this.chartDataCstom.rows[item],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {}
        })),
      }
    },

    drawChartCustom3() {
      let chartDom = document.getElementById("custom_smg_frame")
      if (!chartDom) return
      if (!allChart.custom_smg_frame_chart) {
        allChart.custom_smg_frame_chart = echarts.init(chartDom)
      }
      allChart.custom_smg_frame_chart.setOption(this.getFrameOption(), {notMerge: true})
    },

    drawCharts() {
      this.drawPieChartcustom()
      this.drawPieChartcustomSecond()
      this.drawChartCustom2()
      this.drawChartCustom3()
    },
  }
}


export default {
  mixins: [useCharts],

  inject: ['injectObj'],

  props: {
    testInfo3: Object,
    testInfo: Object,
    customNewFieldsData: Array,
  },

  components: {LabelList, ChartRect},

  data() {
    return {

    }
  },

  computed: {
    project_id() {
      return this.$route.query.project
    },

    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    CustomValue() {
      let data = this.testInfo3

      let list = ["SMG-DrawCall,DrawCall", "SMG-Primitives,Primitives"];
      let data_cus = [];
      list.forEach((v) => {
        data_cus.push({
          label: v,
          value: JSON.stringify(data) === "{}" ? "-" : data?.[v],
        });
      });
      return data_cus;
    },
  },

  methods: {
    async init(isMounted) {
      this.drawCharts()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      this.$refs.chartRect2?.init(isMounted)
      this.$refs.chartRect3?.init(isMounted)
      this.$refs.chartRect4?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>